<div class="titlePageWrapper">
    <div class="filmTop">
        <div class="bg">
            <!-- <img [src]="movie?.pageBg" alt=""> -->
            <app-top-image-rotator *ngIf="movie?.videoBg == '' " [pageBgList]="getBgList()"></app-top-image-rotator>
            <app-top-video *ngIf="movie != undefined && movie?.videoBg != '' " [movie]="movie" ></app-top-video>
        </div>
        <div class="ttWrap">

            <div class="tt">
                <div class="starring">{{starring}}</div>
                <div class="title">{{movie?.Title}}</div>

                <div class="buttons">
                    <div class="roundButton white" (click)="onBook()">
                        <div class="label">
                            Book Now
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="split">
        <div class="left">
            <div class="poster">
                <img [src]="movie?.Poster" alt="">
            </div>

            <div class="posterButtons">
                <div class="roundButton" (click)="onBook()">
                    <div class="label">Book This Film</div>
                </div>

                <div class="roundButton buttonWithPlus" (click)="onWishlist()">
                    <div class="plusIcon">
                        <mat-icon *ngIf="!isInWishlist" class="add">add_2</mat-icon>
                        <mat-icon *ngIf="isInWishlist" class="remove">remove</mat-icon>
                    </div>
                    <div class="label">Add to My List</div>
                    <div class="floating" *ngIf="!isInWishlist">Add to My List</div>
                    <div class="floating" *ngIf="isInWishlist">Remove from List</div>
                </div>
            </div>
        </div>
        <div class="right">
            <div class="details">
                <div class="title">{{movie?.Title}}</div>
                <div class="rightsRestriction" *ngIf="movie?.Rights_Restriction && movie?.Rights_Restriction_Text == ''">RESTRICTIONS MAY APPLY</div>
                <div class="rightsRestriction" *ngIf="movie?.Rights_Restriction && movie?.Rights_Restriction_Text != ''" [innerHtml]="movie?.Rights_Restriction_Text | safeHtml"></div>
                <div class="starring" *ngIf="movie?.CastList?.length ">Starring: {{starring}}</div>

                <div class="synopsis" [innerHTML]="movie?.Synopsis | safeHtml"></div>

                <div class="director list1">
                    Director: <a [routerLink]="['/search/', director]" routerLinkActive="router-link-active"
                        *ngFor="let director of movie?.DirectorList ">{{director}}</a>
                </div>

                <div class="writer list1">
                    Writer: <a [routerLink]="['/search/', item]" routerLinkActive="router-link-active"
                        *ngFor="let item of movie?.WriterList ">{{item}}</a>
                </div>

                <div class="stars list1">
                    Stars: <a [routerLink]="['/search/', item]" routerLinkActive="router-link-active"
                        *ngFor="let item of movie?.CastList ">{{item}}</a>
                </div>

                <div class="rating">
                    Rated: {{movie?.Rating}}
                </div>

                <div class="subSplit">
                    <div class="subLeft">
                        <div class="genre">
                            {{movie?.Genre}}
                        </div>

                        <div class="releaseDate txt">
                            Release date: {{movie?.Release}}
                        </div>

                        <div class="runtome txt">
                            Runtime: {{movie?.Runtime}} minutes
                        </div>

                        <div class="aspect txt" *ngIf="movie?.DCP_Aspect_Ratio != ''">
                            Aspect Ratio: {{movie?.DCP_Aspect_Ratio}}
                        </div>
                    </div>

                    <div class="subRight">
                        <div class="formatsTitle">Available Formats</div>

                        <div class="plf txt">Rights Only – Self Supplied</div>

                        <div class="dcp txt" *ngIf="movie?.DCP && movie?.DCP_Resolution == ''">DCP</div>

                        <div class="plf txt" *ngIf="movie?.DCP && movie?.DCP_Resolution =='4K'">DCP – 4K</div>
                        <div class="plf txt" *ngIf="movie?.DCP && movie?.DCP_Resolution =='2K'">DCP – 2K</div>
                        
                        <div class="plf txt" *ngIf="movie?.ThirtyFiveMmPrint">35mm Print</div>

                        <div class="plf txt" *ngFor="let additionalFormat of additionalFormats" >{{additionalFormat}}</div>

                        <!-- <div class="dcpSample txt" *ngIf="movie?.DCP">
                            DCP – <a href="mailto:sample@deluxe.com" target="_blank">sample&#64;deluxe.com</a>
                        </div> -->
                    </div>
                </div>

                <!-- <div class="sound">
                    Sound: {{movie?.DCP_Aspect_Ratio}}
                </div> -->

                <div class="legal">Films and available formats are subject to final sales team approval.</div>
            </div>

        </div>
    </div>

    <app-poster-list [title]="'You May Also Like'" [movies]="movies" *ngIf="movies.length > 0"></app-poster-list>
    <app-poster-list [title]="'You May Also Like'" [movies]="pageService.homePage.newlyCreatedList" *ngIf="movies.length == 0"></app-poster-list>
    
</div>